<template>
<b-container>
    <b-row>
        {{snumber}}
        <b-col> 
            <div class="my-3 p-3 bg-white rounded shadow-sm"> 
            <h4 class="border-bottom border-gray pb-2 mb-0">Actualizar número de servicio</h4>
            <div class="media text-muted pt-3">
                <b-form   style="width: 100%;">
              
                <b-row>
                    <b-col sm="4">
                    <label>Número de servicio</label>
                    <b-form-group>
                        <b-form-input 
                        v-model="snumber.snumber_snumber"
                        type="text"
                        disabled
                        />
                    </b-form-group>
                    </b-col>
                    <b-col sm="4">
                    <label>Tarifa</label>
                    <b-form-group>
                        <b-form-input 
                        type="text"
                        v-model="snumber.snumber_tariff.tariff_name"
                        disabled
                        />
                    </b-form-group>
                    </b-col>
                    <b-col sm="4">
                    <label>Ciudad</label>
                    <b-form-group>
                        <b-form-input 
                        type="text"
                        v-model="snumber.snumber_city.city_name"
                        disabled
                        />
                    </b-form-group>
                    </b-col>
                </b-row>
                <hr>
                <b-row>
                    <b-col>
                    <label>Vendedor:</label>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="6">
                        <b-form-select v-model="selected" :options="usuarios" value-field="_id" text-field="email"></b-form-select>
                    </b-col>
                    <b-col sm="6">
                    <b-form-group>
                        <b-form-input 
                        type="password"
                        required
                        placeholder="Confirmar contraseña"
                        minlength="6"
                        />
                    </b-form-group>
                    </b-col>
                </b-row>
                
                <b-row>
                    <b-col sm="6">
                    <b-form-group label="Correo electrónico" label-for="input-1">
                        <b-form-input 
                        type="email"
                        required
                        placeholder="Correo electrónico"
                        />
                    </b-form-group>
                    </b-col>
                    <b-col>
                    <b-form-group label="Teléfono" label-for="input-1">
                        <b-form-input 
                        type="tel"
                        required
                        placeholder="Teléfono"  
                        />
                    </b-form-group> 
                    </b-col> 
                </b-row> 
          
                <b-row>
                    <b-col>
                    <b-button class="float-right boton_createch" type="submit" variant="primary">
                        <i class="far fa-save"></i> Registrar
                    </b-button>
                    <!-- <b-button type="reset" variant="danger">Resetear</b-button> -->
                    </b-col>
                </b-row>
                </b-form>
            </div>
            </div> 
        </b-col>
    </b-row>
     <b-row>
         {{selected}} 
    </b-row>
</b-container>
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {
            selected: null,
            snumber: {},
            items: [
                { age: 40, first_name: 'Dickerson', last_name: 'Macdonald' },
                { age: 21, first_name: 'Larsen', last_name: 'Shaw' },
                { age: 89, first_name: 'Geneva', last_name: 'Wilson' },
                { age: 38, first_name: 'Jami', last_name: 'Carney' }
            ],
            fields: [ 
                { key: 'snumber', label: 'No. Servicio' },  
                { key: 'tariff.name', label: 'Tarifa' },
                { key: 'address', label: 'Dirección' },
                { key: 'city.name', label: 'Ciudad' },
                { key: 'owner.name', label: 'Nombre' }, 
                { key: 'owner.email', label: 'Email' }, 
                { key: 'actions', label: '' }
            ],
            packagesTable: { 
                totalRows: 1,
                currentPage: 1,
                perPage: 5,
                pageOptions: [5, 10, 15],
                filter: null,
                filtpackagesTableerOn: []
            },
            deleteModal: {
                id: "info-modal",
                title: "",
                eliminar: null
            },
            usuarios: []
        }
    }, 
    watch:{
        "snumber.snumber_assignedTo": function()  {
            this.selected = this.snumber.snumber_assignedTo._id;
        }
    },
    created() {
        this.gets();
        this.listar();
    },
    methods: {
        listar() {
        let me = this; 
        this.isLoading = true; 
        axios
            .get("users/" + this.$store.state.usuario._id+'/status=true')
            .then(res => {    
                me.usuarios = res.data;   
            })
            .then( res => {
            this.isLoading = false;
            })
            .catch(error => {});
        },
        gets() {  
            axios.get('snumberid/'+this.$route.params.id)
            .then(res => { 
                if (res.data) {  
                    this.snumber = res.data;
                    this.packagesTable.totalRows = res.data.length;
                } 
            })
            .catch(error => {
                this.isLoading = false; 
            });
        }
    }
}
</script>